import React, { useState, useEffect } from "react";
import "./TimeSheet.css";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  addTimesheet,
  clearTimesheet,
  getTimesheetEditData,
  getUserTimesheetList,
} from "../../Redux/TimeSheet/Action";
import { FaEdit, FaEye } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { getLeaveList } from "../../Redux/Leave/Action";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";
import Icon from "../utility/Icon";

const TimeSheet = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const dispatch = useDispatch();
  const { usertimesheetlist, editTimesheet } = useSelector(
    (store) => store.timeSheet
  );
  const { leavelist } = useSelector((store) => store.leave);
  const [week, setWeek] = useState("");
  const [dates, setDates] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [isTimesheetOpen, setIsTimesheetOpen] = useState(false);
  const [filteredTimesheets, setFilteredTimesheets] = useState([]);
  const [hoveredDate, setHoveredDate] = useState(null);
  const [actionType, setActionType] = useState("INSERT");
  const [timesheetpkId, settimesheetpkId] = useState("");
  const [errors, setErrors] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    dispatch(getUserTimesheetList(loginId, token, pageNumber - 1, pageSize));
    dispatch(getLeaveList(token, loginId, currentYear));
  }, [dispatch, loginId, token, pageNumber, pageSize]);

  useEffect(() => {
    if (usertimesheetlist) {
      setFilteredTimesheets(usertimesheetlist.pendingList || []);
    }
  }, [usertimesheetlist]);

  const [timesheet, setTimesheet] = useState({
    actionType: "INSERT",
    timeSheetId: "",
    userId: loginId,
    startDate: "",
    endDate: "",
    sun: 0,
    mon: 0,
    tue: 0,
    wed: 0,
    thu: 0,
    fri: 0,
    sat: 0,
    totalHours: 0,
    rating: 0,
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  const disabledRanges = [
    ...leavelist.map((leave) => ({
      start: parseDate(leave.startDate),
      end: parseDate(leave.endDate),
    })),
    ...filteredTimesheets.map((timesheet) => ({
      start: parseDate(timesheet.startDate),
      end: parseDate(timesheet.endDate),
    })),
  ];

  const handleWeekChange = (date) => {
    const startDate = getStartOfWeek(date);
    const endDate = getEndOfWeek(date);

    if (isWeekAlreadyFilled(startDate, endDate)) {
      alert(
        "This week has already been filled in the timesheet. Please select another week."
      );
      return;
    }
    setWeek(startDate);
    setDates([startDate, endDate]);
  };

  const isDayDisabled = (date) => {
    return disabledRanges.some(
      (range) => date >= range.start && date <= range.end
    );
  };

  const isWeekAlreadyFilled = (startDate, endDate) => {
    return filteredTimesheets.some((timesheet) => {
      const filledStartDate = parseDate(timesheet.startDate);
      const filledEndDate = parseDate(timesheet.endDate);
      return (
        (startDate >= filledStartDate && startDate <= filledEndDate) ||
        (endDate >= filledStartDate && endDate <= filledEndDate) ||
        (startDate <= filledStartDate && endDate >= filledEndDate)
      );
    });
  };

  const getStartOfWeek = (date) => {
    const day = date.getDay();
    const diff = date.getDate() - day;
    return new Date(date.setDate(diff));
  };

  const getEndOfWeek = (date) => {
    const startOfWeek = getStartOfWeek(date);
    return new Date(startOfWeek.setDate(startOfWeek.getDate() + 6));
  };

  const handleHover = (date) => {
    setHoveredDate(date);
  };

  const getDayClassName = (date) => {
    if (hoveredDate) {
      const startOfHoveredWeek = getStartOfWeek(hoveredDate);
      const endOfHoveredWeek = getEndOfWeek(hoveredDate);
      if (date >= startOfHoveredWeek && date <= endOfHoveredWeek) {
        return "week-hover";
      }
    }
    return "";
  };

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleInputChange = (e, day) => {
    const hours = e.target.value;
    if (hours && /^[\s]/.test(hours)) {
      e.preventDefault();
      return;
    }
    if (hours === "" || (Number(hours) >= 0 && Number(hours) <= 10)) {
      setInputValues({
        ...inputValues,
        [day]: hours,
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [day]: "",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [day]: "Please enter a value between 0 and 10.",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasEmptyFields = false;

    daysOfWeek.forEach((day) => {
      const value = inputValues[day];
      if (value === "") {
        hasEmptyFields = true;
      }
      if (value === undefined || value === null) {
        inputValues[day] = 0;
      }
    });

    if (hasEmptyFields) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Submission",
        text: "Please filled your timesheet hours properly.",
      });
    } else {
      const timesheetData = {
        ...timesheet,
        timeSheetId: timesheetpkId,
        actionType: actionType,
        startDate: formatDate(dates[0]),
        endDate: formatDate(dates[1]),
        sun: inputValues["Sunday"] ? parseInt(inputValues["Sunday"]) : 0,
        mon: inputValues["Monday"] ? parseInt(inputValues["Monday"]) : 0,
        tue: inputValues["Tuesday"] ? parseInt(inputValues["Tuesday"]) : 0,
        wed: inputValues["Wednesday"] ? parseInt(inputValues["Wednesday"]) : 0,
        thu: inputValues["Thursday"] ? parseInt(inputValues["Thursday"]) : 0,
        fri: inputValues["Friday"] ? parseInt(inputValues["Friday"]) : 0,
        sat: inputValues["Saturday"] ? parseInt(inputValues["Saturday"]) : 0,
        totalHours: Object.values(inputValues).reduce(
          (sum, hours) => sum + (parseInt(hours) || 0),
          0
        ),
      };
      const result = await Swal.fire({
        title: "Are you sure?",
        html: `Do you want to submit the timesheet details?<br><strong>Total hours worked:</strong> ${timesheetData.totalHours.toFixed(
          2
        )} hours`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel",
      });
      if (result.isConfirmed) {
        dispatch(addTimesheet(timesheetData, token))
          .then(({ success }) => {
            if (success) {
              dispatch(getUserTimesheetList(loginId, token, pageNumber - 1, pageSize));
              setIsTimesheetOpen(false);
              setInputValues({});
              setWeek("");
              setDates([]);
              Swal.fire({
                title: "Success!",
                text: "Timesheet submitted successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "Timesheet submitted unsuccessfull",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the timesheet details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    }
  };

  const handleCreateTimesheet = () => {
    setActionType("INSERT");
    setInputValues({});
    setDates([]);
    setIsTimesheetOpen(true);
    dispatch(clearTimesheet());
  };

  const handleCancel = () => {
    setActionType("INSERT");
    setInputValues({});
    setWeek("");
    setDates([]);
    setIsTimesheetOpen(false);
    dispatch(clearTimesheet());
  };

  const handleEditTimesheet = (row) => {
    settimesheetpkId(row.timeSheetId);
    dispatch(getTimesheetEditData(row.timeSheetId, token));
    setIsTimesheetOpen(true);
  };
  const isLeaveDate = (date, leaveRanges) => {
    return leaveRanges.some((range) => date > range.start && date <= range.end);
  };

  const [readonlyDates, setReadonlyDates] = useState([]);

  useEffect(() => {
    if (
      Array.isArray(editTimesheet) &&
      editTimesheet.length > 0 &&
      isTimesheetOpen
    ) {
      const timesheet = editTimesheet[0];
      setActionType("UPDATE");

      setInputValues({
        Sunday:
          timesheet.sun !== null && timesheet.sun !== undefined
            ? timesheet.sun
            : "",
        Monday:
          timesheet.mon !== null && timesheet.mon !== undefined
            ? timesheet.mon
            : "",
        Tuesday:
          timesheet.tue !== null && timesheet.tue !== undefined
            ? timesheet.tue
            : "",
        Wednesday:
          timesheet.wed !== null && timesheet.wed !== undefined
            ? timesheet.wed
            : "",
        Thursday:
          timesheet.thu !== null && timesheet.thu !== undefined
            ? timesheet.thu
            : "",
        Friday:
          timesheet.fri !== null && timesheet.fri !== undefined
            ? timesheet.fri
            : "",
        Saturday:
          timesheet.sat !== null && timesheet.sat !== undefined
            ? timesheet.sat
            : "",
      });

      const startDate = timesheet.startDate
        ? parseDate(timesheet.startDate)
        : null;
      const endDate = timesheet.endDate ? parseDate(timesheet.endDate) : null;

      if (startDate && endDate) {
        setWeek(startDate);
        setDates([startDate, endDate]);

        const leaveRanges = leavelist.map((leave) => ({
          start: parseDate(leave.startDate),
          end: parseDate(leave.endDate),
        }));

        setReadonlyDates(leaveRanges);
      } else {
        console.warn("Invalid startDate or endDate");
      }
    }
  }, [isTimesheetOpen, editTimesheet]);


  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [selectedRemarkData, setSelectedRemarkData] = useState(null);

  const handleOpenRemarkModal = (row) => {
    setSelectedRemarkData(row); // Set data to be shown in modal
    setIsRemarkModalOpen(true); // Open modal
  };

  const columns = [
    // {
    //   name: "SN",
    //   selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
    //   sortable: false,
    //   width: "60px",
    // },
    {
      name: "Date Range",
      selector: (row) => (
        <div>
          {row.startDate} <br />
          {row.endDate}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Mon",
      selector: (row) => row.mon || "-",
      sortable: false,
    },
    {
      name: "Tue",
      selector: (row) => row.tue || "-",
      sortable: false,
    },
    {
      name: "Wed",
      selector: (row) => row.wed || "-",
      sortable: false,
    },
    {
      name: "Thu",
      selector: (row) => row.thu || "-",
      sortable: false,
    },
    {
      name: "Fri",
      selector: (row) => row.fri || "-",
      sortable: false,
    },
    {
      name: "Sat",
      selector: (row) => row.sat || "-",
      sortable: false,
    },
    {
      name: "Sun",
      selector: (row) => row.sun || "-",
      sortable: false,
    },
    // {
    //   name: "Total",
    //   selector: (row) => row.totalHours,
    //   sortable: false,
    // },
    {
      name: "Status",
      selector: (row) => {
        // Check the isApproved status and return the appropriate string
        switch (row.isApproved) {
          case "Y":
            return "Approved";
          case "N":
            return "Waiting";
          case "B":
            return "Reversed ";
          default:
            return "Unknown Status";
        }
      },
      width: "100px",
      sortable: false,
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.isApproved,
    //   sortable: false,
    // },
    {
      name: "Rating",
      selector: (row) => row.rating || "-",
      sortable: false,
      width: "90px",
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      cell: (row) => (
        <div>


          <Icon
            icon={FaEye}
            variant="secondary"
            title="View"
            onClick={() => handleOpenRemarkModal(row)}
          />



          <Icon
            icon={FaEdit}
            variant="warning"
            title="Edit"
            className="ms-1"
            onClick={() => handleEditTimesheet(row)}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        {!isTimesheetOpen ? (
          <>
            <div className="container-fluid mt-4">
              <div className="row mb-3 justify-content-end align-items-center">
                <div className="col-auto d-flex align-items-center">
                  <button
                    type="submit"
                    id="sbmtdata"
                    className="btn btn-primary"
                    onClick={handleCreateTimesheet}
                  >
                    CREATE TIMESHEET
                  </button>
                </div>
              </div>

              <NewGlobalDataTable
                columns={columns}
                data={filteredTimesheets}
                tableName={'TIMESHEET'}
                setPageSize={setPageSize}
                setPageNumber={setPageNumber}
                totalRecord={usertimesheetlist.totalRecord}
              />

              <div className="mt-4">
                <strong className="text-danger">Note: </strong><em>Please ensure the timesheet is filled in every week.</em>
              </div>

            </div>
            {/* {isRemarkModalOpen && selectedRemarkData && (
            <div
              className="modal fade show"
              tabIndex="-1"
              style={{ display: "block" }}
              // aria-modal="true"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Timesheet Overview</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setIsRemarkModalOpen(false)}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th scope="row">Start Date</th>
                          <td>{selectedRemarkData.startDate}</td>
                        </tr>
                        <tr>
                          <th scope="row">End Date</th>
                          <td>{selectedRemarkData.endDate}</td>
                        </tr>

                        <tr>
                          <th scope="row">Total Hour</th>
                          <td>
                            {selectedRemarkData.totalHours ||
                              "No data available"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Remark</th>
                          <td>
                            {selectedRemarkData.remarks ||
                              "No remark available"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Rating</th>
                          <td>{selectedRemarkData.rating || "Not Approved"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setIsRemarkModalOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )} */}
            {isRemarkModalOpen && selectedRemarkData && (
              <>
                {/* Modal Backdrop */}
                <div className="modal-backdrop fade show"></div>

                {/* Modal */}
                <div
                  className={`modal leave-modal fade ${isRemarkModalOpen ? "show d-block" : ""
                    }`}
                  tabIndex="-1"
                  style={{ display: isRemarkModalOpen ? "block" : "none" }}
                  role="dialog"
                >
                  <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Timesheet Overview</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setIsRemarkModalOpen(false)}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th scope="row">Employee Name</th>
                              <td>{selectedRemarkData.name}</td>
                            </tr>
                            <tr>
                              <th scope="row">Start Date</th>
                              <td>{selectedRemarkData.startDate}</td>
                            </tr>
                            <tr>
                              <th scope="row">End Date</th>
                              <td>{selectedRemarkData.endDate}</td>
                            </tr>
                            <tr>
                              <th scope="row">Net Working Hour</th>
                              <td>{selectedRemarkData.totalHours}</td>
                            </tr>
                            <tr>
                              <th scope="row">Remark</th>
                              <td>
                                {selectedRemarkData.remarks ||
                                  "No remark available"}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Rating</th>
                              <td>
                                {selectedRemarkData.rating || "Not Approved Yet"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setIsRemarkModalOpen(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <div className="container">
              <div className="row g-3 my-3">
                <div className="col-12 col-md-4">
                  <b>
                    <label className="custom-label d-inline">Select Week </label>
                  </b>
                  <br></br>
                  <DatePicker
                    selected={week}
                    onChange={handleWeekChange}
                    showWeekNumbers
                    dateFormat="yyyy-'W'ww"
                    filterDate={(date) => !isDayDisabled(date)}
                    calendarClassName="highlight-calendar"
                    dayClassName={(date) => getDayClassName(date)}
                    onDayMouseEnter={(date) => handleHover(date)}
                    className="form-control"
                  />
                </div>

                {/* Display Start Date */}
                <div className="col-12 col-md-4">
                  <b>
                    <label className="custom-label">Start Date</label>
                  </b>
                  <input
                    type="text"
                    className="form-control"
                    value={dates.length ? formatDate(dates[0]) : ""}
                    readOnly
                  />
                </div>

                {/* Display End Date */}
                <div className="col-12 col-md-4">
                  <b>
                    <label className="custom-label">End Date</label>
                  </b>
                  <input
                    type="text"
                    className="form-control"
                    value={dates.length ? formatDate(dates[1]) : ""}
                    readOnly
                  />
                </div>
              </div>

              <div className="card3">
                <div className="card-body">
                  {dates.length > 0 ? (
                    <div className="row mt-2">
                      <div className="col-12">
                        <div className="leave-hours-wrapper">
                          {/* PC / Large Screen View */}
                          <div className="table-responsive leave-table-pc d-none d-md-block">
                            <table className="table table-bordered text-center custom-leave-table">
                              <thead>
                                <tr>
                                  {daysOfWeek.map((day, index) => {
                                    const dayDate = new Date(dates[0]);
                                    dayDate.setDate(dayDate.getDate() + index);
                                    return (
                                      <th key={index} className="table-header">
                                        {day} <br />
                                        {formatDate(dayDate)}
                                      </th>
                                    );
                                  })}
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  {daysOfWeek.map((day, index) => {
                                    const dayDate = new Date(dates[0]);
                                    dayDate.setDate(dayDate.getDate() + index);

                                    const readOnly =
                                      actionType === "INSERT"
                                        ? isDayDisabled(dayDate)
                                        : isLeaveDate(dayDate, readonlyDates);

                                    return (
                                      <td key={index}>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Hours"
                                          value={
                                            inputValues[day] !== undefined &&
                                              inputValues[day] !== null
                                              ? inputValues[day]
                                              : readOnly
                                                ? 0
                                                : ""
                                          }
                                          onChange={(e) => !readOnly && handleInputChange(e, day)}
                                          readOnly={readOnly}
                                          required
                                        />

                                        {errors[day] && (
                                          <div className="text-danger small">{errors[day]}</div>
                                        )}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          {/* MOBILE CARD VIEW */}
                          <div className="leave-table-mobile d-md-none">
                            {daysOfWeek.map((day, index) => {
                              const dayDate = new Date(dates[0]);
                              dayDate.setDate(dayDate.getDate() + index);

                              const readOnly =
                                actionType === "INSERT"
                                  ? isDayDisabled(dayDate)
                                  : isLeaveDate(dayDate, readonlyDates);

                              return (
                                <div key={index} className="leave-card shadow-sm">
                                  <div className="leave-card-header">
                                    <strong>{day}</strong>
                                    <span>{formatDate(dayDate)}</span>
                                  </div>

                                  <div className="leave-card-body">
                                    <input
                                      type="number"
                                      className="form-control custom-mobile-input"
                                      placeholder="Enter Hours"
                                      value={
                                        inputValues[day] !== undefined &&
                                          inputValues[day] !== null
                                          ? inputValues[day]
                                          : readOnly
                                            ? 0
                                            : ""
                                      }
                                      onChange={(e) => !readOnly && handleInputChange(e, day)}
                                      readOnly={readOnly}
                                      required
                                    />

                                    {errors[day] && (
                                      <div className="text-danger mt-1 small">{errors[day]}</div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col text-center">
                            <button
                              type="submit"
                              className="btn btn-primary me-2"
                              onClick={handleSubmit}
                            >
                              SUBMIT
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handleCancel}
                            >
                              BACK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row mt-4">
                      <div className="col text-center">
                        <p>
                          No dates available. Please provide a valid date range
                          from select week.
                        </p>
                        <button
                          type="button"
                          className="btn btn-info me-2"
                          onClick={handleCancel}
                        >
                          BACK
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TimeSheet;
